import { useState } from 'react';
import Button from '../components/Button';
import { updateStyling } from '../firebase/services';

function Styling() {
    const [font, setFont] = useState('');
    const [loading, setLoading] = useState(false);

    const handleFontUpdate = async () => {
        try {
            setLoading(true);
            await updateStyling({ font });
            alert('Font updated successfully!');
        } catch (error) {
            console.error('Error updating font:', error);
            alert('Failed to update font');
        } finally {
            setLoading(false);
        }
    };

    // Load font for preview when font name changes
    const loadFontForPreview = (fontFamily) => {
        const link = document.createElement('link');
        link.href = `https://fonts.googleapis.com/css2?family=${fontFamily.replace(' ', '+')}&display=swap`;
        link.rel = 'stylesheet';
        document.head.appendChild(link);
    };

    const handleFontChange = (e) => {
        const newFont = e.target.value;
        setFont(newFont);
        if (newFont) {
            loadFontForPreview(newFont);
        }
    };

    return (
        <div className="space-y-6">
            <h1 className="text-3xl font-bold text-white">Style Settings</h1>

            <div className="bg-gray-900 p-6 rounded-lg max-w-md">
                <div className="mb-6">
                    <a
                        href="https://fonts.google.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-pink-500 hover:text-pink-400 underline"
                    >
                        Browse Google Fonts
                    </a>
                    <p className="text-gray-400 mt-2 text-sm">
                        Browse fonts and copy the font family name (e.g. "Roboto" or "Open Sans")
                    </p>
                </div>

                <label className="block text-gray-300 mb-2">Enter Google Font Family Name</label>
                <input
                    type="text"
                    value={font}
                    onChange={handleFontChange}
                    placeholder="e.g. Roboto"
                    className="w-full p-2 rounded bg-gray-800 text-white border border-gray-700 focus:border-pink-500 focus:outline-none"
                />

                {font && (
                    <div className="mt-6 p-4 bg-gray-800 rounded">
                        <h3 className="text-white mb-2">Preview:</h3>
                        <p
                            style={{ fontFamily: `'${font}', sans-serif` }}
                            className="text-gray-300"
                        >
                            The quick brown fox jumps over the lazy dog
                        </p>
                        <p
                            style={{ fontFamily: `'${font}', sans-serif` }}
                            className="text-gray-300 font-bold mt-2"
                        >
                            ABCDEFGHIJKLMNOPQRSTUVWXYZ
                        </p>
                    </div>
                )}

                <div className="mt-6">
                    <Button
                        onClick={handleFontUpdate}
                        disabled={loading || !font}
                    >
                        {loading ? 'Updating...' : 'Update Font'}
                    </Button>
                </div>
            </div>
        </div>
    );
}

export default Styling;